import {Directive, Input, OnInit} from '@angular/core';
import {FormlyFieldConfig, FormlyForm} from '@ngx-formly/core';
import {traverse} from '../formly-utils';

const disableFields = (fields: FormlyFieldConfig[]): void => {
  const compareFn = (key: string, value: any): boolean => key === 'props';
  const processFn = (value: any): any => {
    value.disabled = true;
    return value;
  };
  traverse(fields, compareFn, processFn);
};


@Directive({
  selector: '[zlDisabledForm]',
  standalone: true
})
export class DisabledFormDirective implements OnInit {

  @Input() zlDisabledForm: any = false;

  constructor(private formly: FormlyForm) {

  }

  ngOnInit(): void {
    if (this.zlDisabledForm === true) {
      disableFields(this.formly.fields);
    }
  }

}

